<template>
    <v-container fluid dark flat>
        <div class="overlay-loading" v-if="loadingPedido">
            <LoadingLogo/>
            <h3>Estamos cargando la información de tu pedido.</h3>
        </div>
        <div>
            <InvitacionExpress/>
        </div>
        <v-layout row wrap class="inner-container" justify-center mx-auto>
            <v-container px-0 py-3 flat>
                <v-stepper v-model="e1">
                    <v-stepper-header style="display:none">
                        <v-stepper-step 
							:complete="e1 > 1"
							step="1" 
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Nombre
                        </v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 2"
							step="2"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Elementos</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 3"
							step="3"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Direcciones</v-stepper-step>
                        <v-stepper-step 
							:complete="e1 > 4"
							step="4"
							complete-icon="fas fa-check subheading" 
							edit-icon="fas fa-check subheading" 
							error-icon="fas fa-exclamation-triangle subheading" 
							color="#1f97b9"
							editable
						>Precios</v-stepper-step>
                    </v-stepper-header>
                    <v-stepper-content step="1">
                        <!-- Nombre -->
                        <First/>
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <!-- Elementos -->
                        <Second/>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <Third/>     
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <Fourth/>
                    </v-stepper-content>
                </v-stepper>
            </v-container>
        </v-layout>
        <v-layout row justify-center>

            <!--inicio dialog seba-->
            <!-- <v-dialog v-model="dialogDatosPersonalesE" max-width="1100">
                <v-card tile class="pago-dialog">
                            <v-toolbar card dark color="#1f97b9">
                                <v-toolbar-title>SOLO LOS ULTIMOS DATOS!!!</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-btn class="btn-close-pago-dialog" dark icon @click="dialogDatosPersonalesE = false">
                                    <v-img :src='require("../../assets/static/img/cerrar.png")' alt="icono de cierre" max-height="25" contain></v-img>
                                </v-btn>
                            </v-toolbar>
                            <v-card-text>
                                <v-form ref="datosPersonales">
                                    <v-layout row wrap justify-center align-center>
                                        <v-flex md4 sm4 xs12 px-3>
                                                <v-text-field 
                                                    slot="activator"
                                                    v-model="dataPersonal.apellido"
                                                    label="¿Cuál es su apellido?"
                                                    color="#1f97b9"
                                                   
                                                    :rules="rules.nameRules"
                                                >
                                                <img :src='require("../../assets/static/img/nombre-apellido.png")' alt="icono de datos personales" style="width: 25px;height:25px;" slot="prepend">
                                                </v-text-field>
                                            <v-tooltip right v-model="showTooltip" max-width="350px" :color="typeTooltip == 'warning' ? '#616161' : 'red'">
                                            </v-tooltip>
                                        </v-flex>
                                    </v-layout>
                                </v-form>
                                <v-divider class="my-3"></v-divider>
                                <v-layout row wrap justify-center align-center>
                                    <v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
                                        <v-btn color="#1f97b9" outline large class="third-step-button mt-3" @click="goAfterPersonalDataE()">
                                            <v-layout row wrap pa-3 justify-center align-center>
                                                <span>Siguiente</span>
                                            </v-layout>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>	
                            </v-card-text>
                        <div style="flex: 1 1 auto;"></div>
                </v-card>
            </v-dialog> -->

             <!--fin dialog seba-->

	        <v-dialog v-model="dialogPago" max-width="1100">
                <v-card tile class="pago-dialog">
                <v-toolbar card dark color="#1f97b9">
                    <v-toolbar-title> Estamos casi listos <span>{{  this.dataPersonal.nombrePila }}</span> !!!</v-toolbar-title><!--capturar solo nombre TODO-->
                    <v-spacer></v-spacer>
                    <v-btn class="btn-close-pago-dialog" dark icon @click="dialogPago = false">
                        <v-img :src='require("../../assets/static/img/cerrar.png")' alt="icono de cierre" max-height="25" contain></v-img>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
          	        <v-form ref="formPago">
	          	        <v-layout row wrap justify-center align-center>
                            <v-flex md4 sm4 xs12 px-3>
                                <v-menu
                                    ref="menuDate"
                                    :close-on-content-click="true"
                                    v-model="menu"
                                    :nudge-right="40"
                                    lazy
                                    transition="scale-transition"
                                    offset-y
                                    full-width
                                    min-width="290px"
                                    class="mb-5">
                                    <v-text-field
                                        slot="activator"
                                        v-model="datos.first.date"
                                        label="Seleccione Fecha"
                                        :min="tomorrow"
                                        color="#1f97b9"
                                        readonly
                                        :rules="rules.nameRules"
                                    >
                                        <img :src='require("../../assets/static/img/fecha.png")' alt="icono de fecha" style="width: 25px;height:25px;" slot="prepend">
                                    </v-text-field>
                                    <v-date-picker
                                        v-model="datos.first.date"
                                        :min="tomorrow"
                                        no-title
                                        scrollable
                                        prev-icon="fas fa-chevron-left caption"
                                        next-icon="fas fa-chevron-right caption"
                                        locale="es-mx"
                                        first-day-of-week="1"
                                        style="min-height: 380px;"
                                    >
                                        <v-spacer></v-spacer>
                                        <v-btn flat color="primary" @click="menu = false">Cancelar</v-btn>
                                    </v-date-picker>
                                </v-menu>
                                <v-progress-linear v-show="!mantenedores.tiempo_minimo" :indeterminate="true" color="#1f97b9"></v-progress-linear>
                                <div v-show="mantenedores.tiempo_minimo" class="flex-hour-container v-input v-text-field v-input--is-label-active v-input--is-dirty v-input--is-readonly theme--light">
                                <div class="v-input__prepend-outer">
                                    <img :src='require("../../assets/static/img/hora.png")' alt="icono de horario" style="width: 25px;height:25px;">
                                </div>
                                <div class="hour-picker-container">
                                    <v-select
                                        v-model="datos.first.time"
                                        :items="horas"
                                        @input="validTimeDiff"
                                        :rules="rules.nameRules"
                                        append-icon="fas fa-caret-down"
                                        label="Seleccione Hora"
                                    ></v-select>
                                </div>
                                <v-tooltip right v-model="showTooltip" max-width="350px" :color="typeTooltip == 'warning' ? '#616161' : 'red'">
                                </v-tooltip>
                                </div>
                                <p style="font-size: 12px; color: #ff9c55">Para agendar un servicio dentro de las siguientes 24 horas debe confirmar disponibilidad via WhatsApp <a href="https://wa.me/56965909598" target="_blank" style="color: black">aqui</a></p>
                            </v-flex>
		                </v-layout>
		            </v-form>
	                <v-divider class="my-3"></v-divider>
			        <v-layout row wrap justify-center align-center>
					    <v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
						    <v-btn color="#1f97b9" outline large class="third-step-button mt-3" @click="proceedDialog(1, 'Cotizacion_ProcederPago_Fecha')">
                                <v-layout row wrap pa-3 justify-center align-center>
                                    <span>Reservar</span>
                                </v-layout>
                            </v-btn>
					    </v-flex>
				    </v-layout>	
                </v-card-text>

                <div style="flex: 1 1 auto;"></div>
                </v-card>
	        </v-dialog>

		    <v-dialog v-model="proceedTributary" max-width="1100">
			<v-card tile class="pago-dialog">
				<v-toolbar card dark color="#1f97b9">
					<v-toolbar-title>Estamos casi listos!!!</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn class="btn-close-pago-dialog" dark icon @click="proceedTributary = false">
					<v-img :src='require("../../assets/static/img/cerrar.png")' alt="icono de cerrar ventana" max-height="25" contain></v-img>
					</v-btn>
				</v-toolbar>
				<v-card-text>
					<v-layout row wrap justify-space-between align-center>
							<span class="title precio-container-payment precio-total-payment">Documento Tributario</span> <br>
							<span class="precio-container-payment precio-total-payment">
								<input type="Radio" name="documentoTributario" value="Boleta" v-on:click="tributario('Boleta')"> Boleta
								<input type="Radio" name="documentoTributario" value="Factura" v-on:click="tributario('Factura')"> Factura
							</span>
						</v-layout>
					<div v-if="documentoTributario == 'Factura'">
							<p><h3> Datos Facturación</h3></p>
							<v-text-field
								v-model="factura.rut"
								label="R.U.T"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.razonSocial"
								label="Razón Social"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.giroComercial"
								label="Giro Comercial"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.direccion"
								label="Dirección"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.comuna"
								label="Comuna"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.ciudad"
								label="Ciudad"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="factura.telefono"
								label="Teléfono"
								:rules="rules.nameRules"
								required
							></v-text-field>

							<v-divider class="my-3"></v-divider>	
						</div>
						<div v-if="documentoTributario == 'Boleta'">
							<v-text-field
								v-model="boleta.rut"
								label="R.U.T"
								:rules="rules.nameRules"
								required
							></v-text-field>
							<v-text-field
								v-model="boleta.nombre"
								label="Nombre"
								:rules="rules.nameRules"
								required
							></v-text-field>
						</div>
						<div v-else />
					<v-layout row wrap justify-center align-center>
						<v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
							<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="documentoTributario === '' || (documentoTributario === 'Boleta' && (boleta.rut === '' || boleta.nombre === '')) || (documentoTributario === 'Factura' && (factura.rut === '' || factura.razonSocial === '' || factura.giroComercial === '' || factura.direccion === '' || factura.comuna === '' || factura.ciudad === '' || factura.telefono === ''))" @click="proceedDialog(2, 'Cotizacion_ProcederPago_Tributario')">
								<v-layout row wrap pa-3 justify-center align-center>
									<span>Proceder al pago</span>
								</v-layout>
							</v-btn>
						</v-flex>
					</v-layout>	
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="proceedPayment">
			<v-card>
				<v-toolbar card dark color="#1f97b9">
					<v-toolbar-title>Estamos casi listos!!!</v-toolbar-title>
					<v-spacer></v-spacer>
					<v-btn class="btn-close-pago-dialog" dark icon @click="proceedPayment = false">
					<v-img :src='require("../../assets/static/img/cerrar.png")'  alt="icono de cerrar ventana" max-height="25" contain></v-img>
					</v-btn>
				</v-toolbar>
				<v-card-text>
					<v-form ref="formPago">
						<v-layout row wrap justify-center align-center>
							<v-flex sm8 md8 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'px-5': $vuetify.breakpoint.mdAndUp}">
								<v-list three-line subheader>
                                    <template>
                                        <v-subheader>
                                            Resumen
                                        </v-subheader>
                                    </template>
                                    <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 1 }" @click="selectPayment(1)">
                                        <v-list-tile-content>
                                            <v-layout column md7 sm7 xs12>
                                                <v-list-tile-title row wrap>
                                                    <b>Reserva: <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue * 0.3 | CLP}}</b></span></b>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    Para Agendar garantizando disponibilidad del equipo adecuado en la fecha y hora definida. Se puede anular con 24 horas de anticipación sin costo.
                                                </v-list-tile-sub-title>
                                                
                                            </v-layout>
                                            <!-- <v-layout md5 sm5 xs12 text-xs-right>
                                                <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue * 0.3 | CLP}}</b></span>
                                            </v-layout> -->
                                        </v-list-tile-content>
                                    </v-list-tile>
									<v-divider></v-divider>
                                    <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 1 }" @click="selectPayment(1)">
                                        <v-list-tile-content>
                                            <v-layout column md7 sm7 xs12>
                                                <v-list-tile-title row wrap>
                                                    <b>Saldo: <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue * 0.7 | CLP}}</b></span></b>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    Se paga <b>AL FINALIZAR</b> el servicio, directamente al transportista <b style="color: red;">Solo efectivo o transferencia.</b>
                                                </v-list-tile-sub-title>
                                                
                                            </v-layout>
                                            <!-- <v-layout md5 sm5 xs12 text-xs-right>
                                                <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue * 0.7 | CLP}}</b></span>
                                            </v-layout> -->
                                        </v-list-tile-content>
                                    </v-list-tile>
									<v-divider></v-divider>
                                    <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 1 }" @click="selectPayment(1)">
                                        <v-list-tile-content>
                                            <v-layout column md7 sm7 xs12>
                                                <v-list-tile-title row wrap>
                                                    <b>Total: <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue | CLP}}</b></span></b>
                                                </v-list-tile-title>
                                                <v-list-tile-sub-title>
                                                    El valor del servicio <b v-if="tipoServicio === 1">NO </b><b>incluye carga y descarga.</b>
                                                </v-list-tile-sub-title>
                                                
                                            </v-layout>
                                            <!-- <v-layout md5 sm5 xs12 text-xs-right>
                                                <span class="subheading precio-container-payment precio-discount-payment"> <b>{{paymentValue | CLP}}</b></span>
                                            </v-layout> -->
                                        </v-list-tile-content>
                                    </v-list-tile>
									<v-divider></v-divider>
                                    <!-- <v-list-tile avatar class="payment-selector" :class="{ 'selected-payment': selectedPayment == 3 }" @click="selectPayment(1)">
                                        <v-list-tile-content>
                                        <v-list-tile-title style="height:auto;">
                                                    <v-layout row wrap justify-space-between align-center>
                                                                    <v-flex md7 sm7 xs12>
                                                    Reserva: {{paymentValue * 0.3 | CLP}}
                                                </v-flex>
                                                <v-flex md5 sm5 xs12 text-xs-right>
                                                    <v-text-field
                                                        v-model="toPayValue"
                                                        placeholder="Monto a pagar"
                                                        type="number"
                                                        style="max-width: 200px;"
                                                        class="input-qty-second"
                                                        color="#1f97b9"
                                                        disabled
                                                        :min="paymentValue * 0.3"
                                                        :max="paymentValue * 0.3"
                                                        :messages="abonoMessage"
                                                        persistent-hint
                                                        @input="changeAbono"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-list-tile-title>
                                        </v-list-tile-content>
                                    </v-list-tile> -->
								</v-list>
							</v-flex>
						</v-layout>
					</v-form>
					
			  <v-divider class="my-3"></v-divider>
			  <!-- <p><b>Elige tu medio de pago</b></p> -->
			  <p><b>Ir a Reservar</b></p>
          	<v-layout row wrap justify-center align-center>
          		<!-- <v-flex sm12 md4 xs12 class="text-xs-center">
								<v-img :src='require("../../assets/static/img/webpay-1.png")' alt="logo de webpay" max-height="70" contain></v-img>
          		</v-flex> -->
          		<!-- <v-flex sm12 md4 xs12 class="text-xs-center">
          			<p>Tu pago será procesado de forma segura mediante <b>WebPay Plus</b></p>
          		</v-flex> -->
          		<v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
					<!-- <v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="documentoTributario === '' || toPayValue < paymentValue * 0.3 || toPayValue == 0 || pedidoID == '' || loadingPay || !datetimeOK || !nsPedido" @click="goToPay(toPayValue, pedidoID, 1, 'Cotizacion_PagoTarjeta')">
						<v-layout row wrap pa-3 justify-center align-center>
							<span v-if="!loadingPay">Reserva con tarjetas</span>
							<v-progress-circular
								v-if="loadingPay"
								:size="21"
								:width="3"
								indeterminate
								color="#1f97b9"
								class="mr-2">
							</v-progress-circular><span v-if="loadingPay">Espera un segundo</span>
						</v-layout>
					</v-btn> -->
					<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="documentoTributario === '' || toPayValue < paymentValue * 0.3 || toPayValue == 0 || pedidoID == '' || loadingPay || !datetimeOK || !nsPedido" @click="goToWS()">
						<v-layout row wrap pa-3 justify-center align-center>
							<span v-if="!loadingPay">Quiero Reservar</span>
							<!-- <v-progress-circular
								v-if="loadingPay"
								:size="21"
								:width="3"
								indeterminate
								color="#1f97b9"
								class="mr-2">
							</v-progress-circular><span v-if="loadingPay">Espera un segundo</span> -->
						</v-layout>
					</v-btn>
				</v-flex>
			</v-layout>
			<!-- <v-divider class="my-3"></v-divider>
			<v-layout row wrap justify-center align-center>
          		<v-flex sm12 md4 xs12 class="text-xs-center">
					<v-img :src='require("../../assets/static/img/Logo-khipu-oficial.png")' alt="logo de khipu" max-height="70" contain></v-img>
          		</v-flex>
          		<v-flex sm12 md4 xs12 justify-center align-center class="text-xs-center">
					<v-btn color="#1f97b9" outline large class="third-step-button mt-3" :disabled="documentoTributario === '' || toPayValue < paymentValue * 0.3 || toPayValue == 0 || pedidoID == '' || loadingPay || !datetimeOK || !nsPedido" @click="goToPay(toPayValue, pedidoID, 22, 'Cotizacion_PagoTransferencia')">
						<v-layout row wrap pa-3 justify-center align-center>
							<span v-if="!loadingPay">Reserva con transferencia</span>
							<v-progress-circular
								v-if="loadingPay"
								:size="21"
								:width="3"
								indeterminate
								color="#1f97b9"
								class="mr-2">
							</v-progress-circular><span v-if="loadingPay">Espera un segundo</span>
						</v-layout>
					</v-btn>
				</v-flex>
			</v-layout>  -->
				</v-card-text>
			</v-card>
		</v-dialog>


			<v-dialog
			  v-model="dialogPagoCompleto"
			  max-width="600"
			>
			  <v-card>
          <v-toolbar card dark color="#1f97b9">
            <v-toolbar-title>Solicitud ingresada</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn class="btn-close-pago-dialog" dark icon @click="dialogPagoCompleto = false">
              <v-img :src='require("../../assets/static/img/cerrar.png")' alt="icono de cerrar ventana" max-height="25" contain></v-img>
            </v-btn>
          </v-toolbar>
			    <v-card-text>

          	<v-layout row wrap justify-center align-center>
          		<v-flex sm4 md4 xs12 class="text-xs-center" :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pr-3': $vuetify.breakpoint.mdAndUp}">
								<v-img :src='require("../../assets/static/img/archive.png")' alt="icono de archivo" max-height="70" contain></v-img>
          		</v-flex>
          		<v-flex sm8 md8 xs12 :class="{'px-0': $vuetify.breakpoint.smAndDown, 'pl-3': $vuetify.breakpoint.mdAndUp}">
								<h3>Hemos recibido correctamente el pago.</h3>
								<h4 class="mb-3">Procesaremos tu solicitud a la brevedad</h4>
								<p class="ma-0">Los datos de tu pago son:</p>
								<!-- <p class="ma-0"><b>Código solicitud:</b> {{paymentInfo.id}}</p> -->
								<p class="ma-0"><b>Número Servicio:</b> {{paymentInfo.ns}}</p>
								<p class="ma-0"><b>Monto Pagado:</b> {{paymentInfo.monto | CLP}}</p>
								<p class="ma-0"><b>Fecha de Pago:</b> {{paymentInfo.fecha}}</p>
								<p class="ma-0"><b>Forma de Pago:</b> {{paymentInfo.forma_pago}}</p>
          		</v-flex>
        		</v-layout>		    	

			    </v-card-text>

			    <v-card-actions>
          	<v-layout row wrap justify-center align-center>
          		<v-flex sm12 md12 xs12 justify-center align-center class="text-xs-center">
								<v-btn color="#1f97b9" outline large class="third-step-button mt-3 py-3" @click="dialogPagoCompleto = false">
									Genial!
								</v-btn>
							</v-flex>
						</v-layout>
			    </v-card-actions>
			  </v-card>
			</v-dialog>
	  </v-layout>
    </v-container>
</template>
<script>
import LoadingLogo from '../../helpers/LoadingLogo'
import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import axios from 'axios'
import cryptoJS from 'crypto-js'
import * as distance from 'google-distance-matrix'
import { EventBus } from '../../events.js'
import First from './Mudanza/First'
import Second from './Mudanza/Second'
import Third from './Mudanza/Third'
import Fourth from './Mudanza/Fourth'
import InvitacionExpress from '../../components/Site/InvitacionExpress'

export default {
    title: 'Cotización ',
    components: {
        LoadingLogo,
        First,
        Second,
        Third,
        Fourth,
        InvitacionExpress
    },
    data () {
        return {
            phoneLength: 9,
            codigoDefault: '+56',
            codigos: ['+56', '+51','+54','+55', '+56','+57','+58','+1','+591','+593','+595','+598'],
            loadingPedido: false,
            e1: 1,
            rules: {
                nameRules: [
                    v => !!v || 'Campo obligatorio'
                ],
                emailRules: [
						v => !!v || 'Campo obligatorio',
						v => {
							const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
							if(re.test(v)){
								return true
							}
							return 'Verifica que el email sea válido'
						}
					]
            },
            stepValidation: {
                first: false,
                second: false,
                third: false,
                fourth: false
            },
            datos: {
                first: {},
                second: {},
                third: {},
                baseValue: 0
            },
            tryChange: {
                first: false,
                second: false,
                third: false,
                fourth: false
            },
            pedidoID: '',
            controlSavedPedido: false,
            dialogPago: false,
            menu: false,
            today: new Date().toISOString().substr(0, 10),
            mantenedores: {},
            horas: ['00:00','00:15','00:30','00:45','01:00','01:15','01:30','01:45','02:00','02:15','02:30','02:45','03:00','03:15','03:30','03:45','04:00','04:15','04:30','04:45','05:00','05:15','05:30','05:45','06:00','06:15','06:30','06:45','07:00','07:15','07:30','07:45','08:00','08:15','08:30','08:45','09:00','09:15','09:30','09:45','10:00','10:15','10:30','10:45','11:00','11:15','11:30','11:45','12:00','12:15','12:30','12:45','13:00','13:15','13:30','13:45','14:00','14:15','14:30','14:45','15:00','15:15','15:30','15:45','16:00','16:15','16:30','16:45','17:00','17:15','17:30','17:45','18:00','18:15','18:30','18:45','19:00','19:15','19:30','19:45','20:00','20:15','20:30','20:45','21:00','21:15','21:30','21:45','22:00','22:15','22:30','22:45','23:00','23:15','23:30','23:45'],
            typeTooltip: 'warning',
            showTooltip: false,
            proceedTributary: false,
            documentoTributario: '',
            boleta: {
                nombre:'',
                rut: ''
            },
            factura: {
                rut:'',
                razonSocial: '',
                giroComercial: '',
                direccion: '',
                comuna: '',
                ciudad: '',
                telefono: ''
            },
            proceedPayment: false,
            selectedPayment: 1,
            ofertaActiva: false,
            paymentValue: 0,
            abonoMessage: '',
            toPayValue: 0,
            loadingPay: false,
            dialogPagoCompleto: false,
            paymentInfo: {
                id: '',
                monto: 0,
                fecha: '',
                forma_pago: ''
            },
            
            datetimeOK: true,
            dataPersonal: {
                nombre: '',
                apellido: '',
                nombreCompleto: '',
                email: '',
                telefono: '',
            },
            dialogDatosPersonalesE: false,
            tomorrow: '',
            dialogPersonalesValidate: false,
            nsPedido: null,
            tipoServicio: 0,
            fromDemo: false
        }
    },
    methods: {
        goToWS(){
            const url = 'https://wa.me/56996711666?text=QuieroReservar'
            const windowOpen = window.open(url)
            windowOpen
        },
        goAfterPersonalDataE() {
            this.dataPersonal.nombreCompleto =  this.datos.first.personales.nombre + ' ' + this.dataPersonal.apellido
            const data = {
                usuario: {
					nombre: this.dataPersonal.nombreCompleto,
					email: this.dataPersonal.email,
					telefono: this.dataPersonal.telefono,
                    nombrePila: this.datos.first.personales.nombre,
                    apellido: this.dataPersonal.apellido
				}
			}
			const db = firebase.firestore()
			db.collection('pedidos').doc(this.pedidoID).update(data)
            this.dialogPago = true
            this.dialogDatosPersonalesE = false
        },
        tributario(documento){
            this.documentoTributario = documento
        },
        proceedDialog(type, tipo){
            if (type === 1) {
                this.proceedTributary === false ? this.proceedTributary = true : this.proceedTributary = false
                this.dialogPago === false ? this.dialogPago = true : this.dialogPago = false
            } else if (type === 2) {
                this.proceedTributary === false ? this.proceedTributary = true : this.proceedTributary = false
                this.proceedPayment === false ? this.proceedPayment = true : this.proceedPayment = false
            }
            this.eventTracker(tipo)
        },
        eventTracker(tipo) {
            gtag('event', tipo, {
            'event_category' : tipo,
            'event_label' : tipo
            })
        },
        async goToPay(valor, idPedido, paymentMethod, tipo){
            const here = this
            this.eventTracker(tipo)
            /* if(this.time_diff >= 0) { */
                this.colorTooltipActivator = '#1f97b9'
                this.loadingPay = true
                let db = firebase.firestore()
                if (here.documentoTributario == 'Factura') {
                    const documento_tributario = {
                        documento_tributario: {
                            documento: here.documentoTributario,
                            factura: here.factura
                        }
                        
                    }
                    await db.collection('pedidos').doc(idPedido).update(documento_tributario)
                } else if (here.documentoTributario == 'Boleta') {
                    const documento_tributario = {
                        documento_tributario: {
                            documento: here.documentoTributario,
                            boleta: here.boleta
                        }
                    }
                    await db.collection('pedidos').doc(idPedido).update(documento_tributario)
                }
                db.collection("pagos").add({
                    id_pedido: idPedido,
                    monto: valor,
                    estado: 'Esperando Pago',
                    fecha_ingreso: firebase.firestore.FieldValue.serverTimestamp()
                })
                .then(function(docRef) {
                        here.payFlow(valor, docRef.id, idPedido, paymentMethod)
                })
                .catch(error => {
                    here.loadingPay = false
                })
                const updatePedido = {
                    fecha: this.datos.first.date,
                    hora: this.datos.first.time
                }
                db.collection('pedidos').doc(idPedido).update(updatePedido)
            /* } else if(this.time_diff < 0){
                this.showTooltip = true
                this.colorTooltipActivator = 'red'
            } */
        },
        payFlow(valor, idPago, idPedido, paymentMethod){
            const here = this
            let flow_params = {
                amount: valor,
                apiKey: '58D1DFFC-908B-43E9-80D0-1LA6424AC4FD', //Producción
                // apiKey: '3C7F5DF0-1742-402A-975C-9F5D29FF5LC2', //Desarrollo
                commerceOrder: idPago,
                email: this.dataPersonal.email,
                /* optional: JSON.stringify({'idPedido': idPedido}), */
                optional: JSON.stringify({'idPedido': idPedido,'tipo': 1}),
                paymentMethod: paymentMethod,
                subject: 'Pago Transportes DUO: ' + idPedido,
                    urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlow', //Producción
                /* urlConfirmation: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/verificarFlowDev', */ //Desarrollo
                urlReturn: 'https://us-central1-duoapp-56ef2.cloudfunctions.net/finalFlow'
            }
            let data = ''
            let signData = ''
            let cont = 0
            console.log("flow_params: ",flow_params)
            Object.keys(flow_params).forEach(function(key) {
                signData += '&' + key + '=' + flow_params[key]
                data += '&' + encodeURIComponent(key) + '=' + encodeURIComponent(flow_params[key])
                cont++
                if(cont === 9){
                    signData = signData.substring(1)
                    data = data.substring(1)
                    here.signAndSend(signData)
                }
            });

        },
        signAndSend(signData){
            const here = this
            const signature = cryptoJS.HmacSHA256(signData, '83558e934b88eeab5293faa6cf9a4d19aae1b937') //Producción
            // const signature = cryptoJS.HmacSHA256(signData, '66c129032423c9e8fa06e0627fbf1be0c0ef8276') //Desarrollo
            const payFlow = firebase.functions().httpsCallable('initFlow')
            axios({
                    method: 'post',
                    url: 'https://cors-anywhere.herokuapp.com/https://www.flow.cl/api/payment/create', //Producción
                    // url: 'https://cors-anywhere.herokuapp.com/https://sandbox.flow.cl/api/payment/create', //Desarrollo
                    /* url: 'https://cors-proxy.htmldriven.com/https://www.flow.cl/api/payment/create', */
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                data: signData + '&s=' + signature
                })
                .then(response => {
                    gtag('event', 'conversion', {
                        'send_to': 'AW-867600071/CSwpCLKi--0CEMeN2p0D',
                        'value': 1.0,
                        'currency': 'CLP',
                        'transaction_id': 'cotizacion'
                    });
                    window.location.href = response.data.url + "?token=" + response.data.token
                })
                .catch(error => {
                console.log("Error Flow: ", error)
                    here.loadingPay = false
                })

        },
        changeAbono(){
            this.abonoMessage = 'Saldo por pagar $' + Math.ceil(this.paymentValue - this.toPayValue).toLocaleString()
        },
        getDistanceMatrix(){
            return new Promise(async(resolve, reject) => {
                const here = this
                var service = new google.maps.DistanceMatrixService()
                await service.getDistanceMatrix(
                    {
                        origins: [this.datos.first.direccion_origen.direccion],
                        destinations: [this.datos.first.direccion_destino.direccion],
                        travelMode: 'DRIVING'
                    },
                    function (response, status) {
                        here.datos.first.distancia = response.rows[0].elements[0]
                        resolve(true)
                    }
                )
            })
        },
        setInitialHour(){
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 3)
            this.datos.first.date = tomorrow.toISOString().substr(0, 10)
            const date = this.$moment().add(this.mantenedores.tiempo_minimo/3600,'h').add(5,'m')
            let horas = date.hour()
            let minutos = date.minute()
            if(minutos == 0 || minutos == 15 || minutos == 30 || minutos == 45 ){}
            else if(minutos < 15){ minutos = 15 }
            else if(minutos < 30){ minutos = 30 }
            else if(minutos < 45){ minutos = 45 }
            else if(minutos < 60){
                if(minutos > 45){
                    minutos = 0
                    horas++
                    if(horas == 24){horas = 0}
                }
            }
            let h = horas.toString()
            let m = minutos.toString()
            if(horas < 10){ h = '0' + horas.toString() }
            if(minutos < 10){ m = '0' + minutos.toString() }
            this.datos.first.time = h + ':' + m
        },
        get_mantenedores(){
            let db = firebase.firestore()
            let self = this
            db.collection("mantenedores").doc("mantenedores").get().then(function(doc) {
                    if (doc.exists) {
                            self.mantenedores = doc.data()
                            self.setInitialHour()
                            //self.initHoursPicker()
                            EventBus.$emit('emmitMantenedores', self.mantenedores);
                    } else {
                            // doc.data() will be undefined in this case
                            console.log("No such document!");
                    }
            }).catch(function(error) {
                    console.log("Error getting document:", error);
            });
        },
        validTimeDiff(){
            this.datetimeOK = true
            const now = this.$moment()
            let hour_selected = this.$moment(this.datos.first.date + ' ' + this.datos.first.time, this.$moment.defaultFormat)
            let hour_limit = this.$moment().add(this.mantenedores.tiempo_minimo, 'seconds')
            this.time_diff = hour_selected.diff(hour_limit, 'seconds')
            if (this.time_diff <= 0 && this.mantenedores){
                if(!this.mantenedores.tiempo_minimo){
                    return true
                }
                this.typeTooltip = 'danger'
                this.colorTooltipActivator = 'red'
                if(this.dialogPago){
                    this.showTooltip = true
                }
                else{
                    this.showTooltip = false
                }
                this.datetimeOK = false
                return false
            }
            else{
                this.colorTooltipActivator = '#1f97b9'
                this.typeTooltip = 'warning'
                return true
            }
        },
        async save_data(data){
            const here = this
            //Guarda información del pedido en la BD, en espera de pago (Para pedido básico y completo)
            let oferta = {
                glosa: '',
                monto: '',
                activo: false,
                campo: '',
                completo: ''
            }
            if (data.first && data.first.oferta && data.first.oferta.activo) {						
                oferta = data.first.oferta
            }
            let idCliente = this.$store.state.idCliente
            const pedido = {
                usuario: data.first.personales,
                direcciones: {
                    origen: data.first.direccion_origen.direccion,
                    destino: data.first.direccion_destino.direccion
                },
                elementos: data.second,
                fecha: data.first.date,
                hora: data.first.time,
                fecha_servicio_obj: new Date(data.first.date + 'T' + data.first.time),
                datosDireccion: {
                    origen: data.third.origen,
                    destino: data.third.destino
                },
                datoPagos: [],
                basicoValue: data.basicoValue,
                completoValue: data.completoValue,
                created: firebase.firestore.FieldValue.serverTimestamp(),
                estado: 'Cotización',
                servicio: data.servicio,
                paymentValue: 0,
                tipo: this.datos.tipo,
                distancia: this.datos.first.distancia,
                tiempos: {
                    distancia: Math.round(this.datos.first.distancia.duration.value/60),
                    carga: this.tiempoCarga(this.datos.second)
                },
                cargos: [],
                descuentos: [],
                registroOferta:[],
                clienteID: idCliente,
                backUpService: false,
                cotizacionExpress: false,
                oferta
            }
            this.fromDemo ? pedido.fromDemo = true : pedido.fromDemo = false
            if (this.dialogPersonalesValidate) {
                pedido.usuario.email = this.dataPersonal.email,
                pedido.usuario.telefono = this.dataPersonal.telefono
            }
            if (this.mantenedores.ajuste_mudanza > 0) {
                const valorAjusteBasico = pedido.basicoValue.amount * (1 - this.mantenedores.ajuste_mudanza)
                const valorAjusteCompleto = pedido.completoValue !== 0 ? pedido.completoValue.amount * (1 - this.mantenedores.ajuste_mudanza) : 0
                pedido.ajuste_mudanza = {
                    ajuste_porcentaje: this.mantenedores.ajuste_mudanza,
                    ajuste_valorBasico: Math.ceil(valorAjusteBasico / 1000) * 1000 - 10,
                    ajuste_valorCompleto: valorAjusteCompleto !== 0 ?  Math.ceil(valorAjusteCompleto / 1000) * 1000 - 10 : 0
                }
            }
            let db = firebase.firestore()
            
            if(here.pedidoID != ''){
                db.collection("pedidos").doc(here.pedidoID).set(pedido, {merge: true})
                    .then(function() {
                        const createNSpedido = firebase.functions().httpsCallable('createNSPedido')
                        createNSpedido({idPedido: here.pedidoID})
                            .then(function(result){
                                here.nsPedido = result
                            })
                            .catch(function(error){
                                console.log("createNSPedido error: ", error)
                                console.log('se cae cuando está creado')
                            })
                        EventBus.$emit('idPedido', {pedidoID: here.pedidoID})
                    })
                    .catch(function(error) {
                        console.error("Error writing document: ", error);
                    });
            }
            else{
                await db.collection("pedidos").add(pedido)
                    .then(function(docRef) {
                        here.pedidoID = docRef.id
                        const createNSpedido = firebase.functions().httpsCallable('createNSPedido')
                        createNSpedido({idPedido: here.pedidoID})
                            .then(function(result){
                                here.nsPedido = result
                            })
                            .catch(function(error){
                                console.log("createNSPedido error: ", error)
                                console.log('se cae cuando no está creado')
                            })
                        EventBus.$emit('idPedido', {pedidoID: here.pedidoID})
                    })
                    .catch(function(){
                        console.error("Error writing document: ", error);
                    });
            // db.collection('system_info').doc('pedidos').update({
            //     qty_pedidos: firebase.firestore.FieldValue.increment(1)
            // })
            }
        },
        tiempoCarga(elementos){
            let volumen = 0
            elementos.forEach(function(item){
                volumen += item.metros * item.qty
            })
            return Math.round( (volumen * this.mantenedores.vol_tiempo) * 100 ) / 100
        },
        getTopayValue(data){
            if(data.type === 1 && data.finalDataSave){
                if(data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && !data.finalDataSave.first.oferta.completo && !data.finalDataSave.ajuste_mudanza){
                    this.paymentValue = data.finalDataSave.basicoValue.amount
                    return data.finalDataSave.basicoValue.amount - data.finalDataSave.first.oferta.monto
                } else if (data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && !data.finalDataSave.first.oferta.completo && data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorBasico - data.finalDataSave.first.oferta.monto
                }
                if (data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorBasico
                }
                this.paymentValue = data.finalDataSave.finalValue.amount
                return data.finalDataSave.basicoValue.amount
            }
            else if(data.type === 2){
                if(data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && data.finalDataSave.first.oferta.completo && !data.finalDataSave.ajuste_mudanza){
                    this.paymentValue = data.finalDataSave.finalValue.amount
                    return data.finalDataSave.finalValue.amount - data.finalDataSave.first.oferta.monto
                } else if (data.finalDataSave.first && data.finalDataSave.first && data.finalDataSave.first.oferta && data.finalDataSave.first.oferta.completo && data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto - data.finalDataSave.first.oferta.monto
                }
                if (data.finalDataSave.ajuste_mudanza) {
                    this.paymentValue = data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                    return data.finalDataSave.ajuste_mudanza.ajuste_valorCompleto
                }
                this.paymentValue = data.finalDataSave.finalValue.amount
                return data.finalDataSave.finalValue.amount
            }
        },
        selectPayment(type, data){
            this.selectedPayment = type
            if(type === 1){ this.toPayValue = Math.ceil(this.paymentValue * 0.3) }
            else if(type === 2){ this.toPayValue = Math.ceil(this.paymentValue * 0.3)}
        },
        setNextDay() {
            const today = new Date()
            const tomorrow = new Date(today)
            tomorrow.setDate(tomorrow.getDate() + 3)
            this.tomorrow = tomorrow.toISOString().substr(0, 10)
        },
        get_pedido(id){
				this.loadingPedido = true
				let db = firebase.firestore()
				let self = this
				db.collection("pedidos").doc(id).get().then(function(doc) {
						if (doc.exists) {
							EventBus.$emit('closeServiceQuestion', false);
							self.pedidoID = id //lleva el id del documento en la bd
                            
							EventBus.$emit('idPedidoRetomar', {pedidoID: self.pedidoID, retomarPedido: true, data: doc.data()})
							// Dejamos la data del pedido en la variable data y asignamos a esa data si se debe cambiar de paso en data.move (boolean)
							let data = doc.data()
							self.pedidoContinuado = doc.data()
                            self.nsPedido = data.NS
							data.move = self.$route.query.move && self.$route.query.move == 1
							data.continue = self.$route.query.continue && self.$route.query.continue == 1
							// Emitimos sólo una vez el retomarPedido
							if (!data.usuario.nombrePila || data.usuario.nombrePila) {
								const arrayApellido = data.usuario.nombre.split([' '], [2])
								const nombre = arrayApellido[0]
								let apellido = ' '
								if (arrayApellido[1] !== undefined) {
									apellido = arrayApellido[1]
								}
								data.usuario.nombrePila = nombre
								data.usuario.apellido = apellido
							}
							self.datos = {
								first:{
									personales: {
										nombre: data.usuario.nombre,
										telefono: data.usuario.telefono,
										email: data.usuario.email,
										apellido: data.usuario.apellido,
										nombrePila: data.usuario.nombrePila
									},
									date: data.fecha,
									time: data.hora,
									direccion_origen:{
										direccion: data.direcciones.origen
									},
									direccion_destino:{
										direccion: data.direcciones.destino
									},
									oferta: data.oferta,
                                    distancia: data.distancia
								},
								second: data.elementos,
								third: data.datosDireccion,
								tiempos: data.tiempos,
								baseValue: data.basicoValue,
                                finalValue: data.completoValue,
								fecha_servicio_obj: data.fecha_servicio_obj,
							}
                            if (data.ajuste_mudanza && data.ajuste_mudanza.ajuste_porcentaje && data.ajuste_mudanza.ajuste_porcentaje > 0) {
                                self.datos.ajuste_mudanza = data.ajuste_mudanza
                            }
                            EventBus.$emit('retomarPedidoFirst', self.datos.first)
                            EventBus.$emit('retomarPedidoSecond', self.datos.second)
                            EventBus.$emit('retomarPedidoThird', self.datos)
                            EventBus.$emit('retomarPedidoFourth', self.datos)
                            self.loadingPedido = false
							// obtener datos tributarios
							if (data.documento_tributario) {
								if (data.documento_tributario === 'Boleta') {
									const datosTributarios = {
										documentoTributario: 'Boleta',
										boleta: {
											nombre: data.documento_tributario.boleta.nombre,
											rut: data.documento_tributario.boleta.rut
										}
									}
									data.datosTributarios = datosTributarios
								}
							}
						} else {
								// doc.data() will be undefined in this case
							console.log("No such document!");
						}
				}).catch(function(error) {
						console.log("Error getting document:", error);
						self.loadingPedido = false
				});

			},
    },
    mounted () {
        this.get_mantenedores()
        this.setNextDay()
        if(this.$route.query.id){ this.get_pedido(this.$route.query.id) }
        if(this.$route.query.demo) {this.fromDemo = true}
        console.log(this.fromDemo + ' esto es del demo')
        EventBus.$on('mudanzaFirst', async data => {//ver este
            if (!data.directions) {
                /* console.log('eso si') */
                this.tryChange.first = true
                this.stepValidation.first = data.valid
                this.dataPersonal.nombre = data.datos.personales.nombre
                this.dataPersonal.apellido = data.datos.personales.apellido
                this.dataPersonal.nombrePila = data.datos.personales.nombre + ' ' + data.datos.personales.apellido
                EventBus.$emit('retomarPedidoFirstReady')
                if(data.valid){
                    this.datos.first = data.datos
                    if(data.move){
                        this.e1 = 2
                        this.tryChange.first = false
                        window.scrollTo(0,0)
                    }
                }
            }
        })
        EventBus.$on('avanzarRetomar', data => {
            this.e1 = data.e1
        })
        EventBus.$on('retroceder', async data => {
            this.e1 = data 
            window.scrollTo(0,0)
        })
        EventBus.$on('mudanzaSecond', async data => {
            this.tryChange.second = true
            this.stepValidation.second = data.valid
            if(data.valid){
                this.datos.second = data.datos
                if(data.qty <= this.mantenedores.qty_mudanza){
                    this.datos.tipo = "Flete"
                }
                else{
                    this.datos.tipo = "Mudanza"
                }
                if(data.move){
                    this.e1 = 3
                    this.tryChange.second = false
                    window.scrollTo(0,0)
                    /* console.log(this.datos) */
                }
            }
        })
        EventBus.$on('mudanzaThird', async data => {
            this.tryChange.third = true
            this.stepValidation.third = data.valid
            if(data.valid){
                this.datos.third = data.datos
                this.datos.first.direccion_origen = this.datos.third.direccion_origen
                this.datos.first.direccion_destino = this.datos.third.direccion_destino
                /* console.log('============')
                console.log(data) */
                this.datos.third.destino = data.datos.destino
                this.datos.third.origen = data.datos.origen
                this.datos.dialogPersonalesValidate = this.dialogPersonalesValidate
                if (this.dialogPersonalesValidate) {
                    this.datos.dataPersonal = {
                        email: this.dataPersonal.email,
                        telefono: this.dataPersonal.telefono
                    }
                }
                this.setInitialHour()
                await this.getDistanceMatrix()
                EventBus.$emit('enterMudanzaFourth', this.datos)
                if(data.move){
                    this.e1 = 4
                    this.tryChange.third = false
                    window.scrollTo(0,0)
                    /* console.log(this.datos) */
                }
            }
        })
        EventBus.$on('goBackMudanza', data => {
            this.e1 = data - 1
            window.scrollTo(0,0)
        })
        EventBus.$on('finalValue', data => {
            /* console.log(data) */
            this.save_data(data)
        })
        EventBus.$on('datosDialogPersonales', data => {//nuevo on
            this.dataPersonal.email = data.usuario.email
            this.dataPersonal.telefono = data.usuario.telefono
            /* console.log(this.dataPersonal) */
            this.dialogPersonalesValidate = true
        })
        EventBus.$on('goForwardFinal', data => {
            console.log(data)
            this.e1 = data.move
        })
        EventBus.$on('reservaPedido',  async data => {
            this.save_data(data.finalDataSave)
            if (data.finalDataSave.first.oferta.activo == true) {
                this.ofertaActiva = true
                this.paymentValue = await this.getTopayValue(data)
            } else {
                await this.getTopayValue(data)
            }
            this.tipoServicio = data.type // 1 basico; 2 completo
            /* console.log('A reservar pedido')
            console.log(data) */
            if (data.documento_tributario) {
                /* console.log('Entra al documento Tributario') */
                if (data.documento_tributario === 'Boleta') {
                    self.documentoTributario = 'Boleta'
                    self.boleta.nombre = data.documento_tributario.boleta.nombre
                    self.boleta.rut = data.documento_tributario.boleta.rut
                }
            }
            /* console.log(this.paymentValue) */
            this.setInitialHour()
            //this.initHoursPicker()
            const here = this
            this.showTooltip = true
            setTimeout(function() {
                here.showTooltip = false
            }, 5000);
            this.dialogPago = true
            /* this.dialogDatosPersonalesE = true */
            this.selectPayment(1, data)
        })
    }
}
</script>